import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-action__title" }
const _hoisted_2 = { class: "confirm-action__description" }
const _hoisted_3 = { class: "confirm-action__actions" }

import { computed, ref } from "vue";
import { i18n } from "@/i18n";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmActionDropdown',
  props: {
    title: { default: undefined },
    description: { default: '' },
    cancelLabel: { default: undefined },
    confirmLabel: { default: undefined }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const resolvedTitle = computed(() => props.title ?? String(i18n.global.t('confirm_action_title')))
const resolvedCancelLabel = computed(() => props.cancelLabel ?? String(i18n.global.t('cancel_short')))
const resolvedConfirmLabel = computed(() => props.confirmLabel ?? String(i18n.global.t('confirm_short')))

const emit = __emit

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$root",
    ref: $root,
    class: "confirm-action"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(resolvedTitle.value), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.description), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppButton, {
        class: "confirm-action__actions-button",
        type: "secondary",
        label: resolvedCancelLabel.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        class: "confirm-action__actions-button",
        label: resolvedConfirmLabel.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, null, 8, ["label"])
    ])
  ], 512))
}
}

})